/**
if (window.location.href.indexOf("myshopify.com") > -1) {
  let multiplePressimages = document.querySelectorAll('.multiple_image img');
  multiplePressimages?.forEach((multiplePressimg) => {
    multiplePressimg.classList.add('fade-in');
    multiplePressimg.src = multiplePressimg.getAttribute('data-src');
  });
}
**/

//LightBox JS
let multipleImages = document.querySelectorAll('.multiple_image img');
let pressLightboxImage = document.querySelector('.press_lightbox_image');
multipleImages?.forEach(function(multipleImage){
  multipleImage.addEventListener('click', function(){
    let ImageSource = this.getAttribute('src');
    pressLightboxImage.setAttribute('src', ImageSource);
    document.querySelector('.press_lightbox').classList.remove('hidden');
  });
});

//Close Lightbox
let pressLightboxClose = document.querySelector('.press_lightbox_close');
let pressLightboxImageContainer = document.querySelector('.press_lightbox_image_container');
pressLightboxClose.addEventListener('click', function(){
  document.querySelector('.press_lightbox').classList.add('hidden');
  pressLightboxImage.setAttribute('src', '');
});

pressLightboxImageContainer.addEventListener('click', (e) => {
  let pressLightboxIimage = document.querySelector('.press_lightbox_image');
  if (!pressLightboxIimage.contains(e.target)) {
    pressLightboxImage.setAttribute('src', '');
    document.querySelector('.press_lightbox').classList.add('hidden');
  }
});

//Load More
let lazyImages = document.querySelectorAll('.multiple_image img[data-src]');
let loadMoreBtn = document.querySelector('#load-more-btn');
let whiteOverlay = document.querySelector('.white_overlay');

let isMobile = window.innerWidth < 768;
let imagesPerBatch = isMobile ? 10 : 20;
let currentItem = imagesPerBatch;

// Function to observe and lazy load images
/**
function observeLazyImages(images) {
  if ('IntersectionObserver' in window) {
    let imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          let img = entry.target;
          img.src = img.getAttribute('data-src');  // Load the image
          img.classList.add('fade-in');  // Add fade-in effect
          img.removeAttribute('data-src');  // Clean up the attribute
          observer.unobserve(img);  // Stop observing once loaded
        }
      });
    });

    images.forEach(img => imageObserver.observe(img));
  } else {
    images.forEach(img => {
      img.src = img.getAttribute('data-src');
    });
  }
}
**/

// Show the initial set of images
/**
function showInitialImages() {
  for (let i = 0; i < currentItem; i++) {
    if (lazyImages[i]) {
      lazyImages[i].parentElement.style.display = "inline-block";
    }
  }
  observeLazyImages(Array.from(lazyImages).slice(0, currentItem));
}
**/

// Handle "Load More" button click for mobile
if (isMobile && loadMoreBtn) {
  loadMoreBtn.addEventListener('click', function () {
    $( ".multiple_images_block" ).addClass( "showall" );

    // Hide the button and overlay after all images are shown
    loadMoreBtn.style.display = "none";
    if (whiteOverlay) {
      whiteOverlay.style.display = "none";
    }

  });
}

// Load more on scroll for desktop
/**
if (!isMobile) {
  window.addEventListener('scroll', function () {
    if (currentItem < lazyImages.length) {
      let multipleImages = document.querySelectorAll('.multiple_image');
      let lastImage = multipleImages[currentItem - 1];
      let lastImageOffset = lastImage.getBoundingClientRect().top + window.scrollY;
      let scrollPosition = window.innerHeight + window.scrollY;

      if (scrollPosition > lastImageOffset) {
        for (let i = currentItem; i < currentItem + imagesPerBatch; i++) {
          if (multipleImages[i]) {
            multipleImages[i].style.display = "inline-block";
            let img = multipleImages[i].querySelector('img[data-src]');
            if (img) observeLazyImages([img]);
          }
        }

        currentItem += imagesPerBatch;
      }
    }
  });
}
**/
// Initial display of images
/**
showInitialImages();
**/

//Organize Image using TJ Gallery Plugin
// waiting for loading page
    $(window).load(function(){
        if (parseInt($(window).width()) > 1920) {
            $('.multiple_images_block').tjGallery({
              selector:'.multiple_image',
              margin: 10,
              rowMinHeight: 500
            });
        } else if (parseInt($(window).width()) > 750) {
            $('.multiple_images_block').tjGallery({
              selector:'.multiple_image',
              margin: 10,
              rowMinHeight: 370
            });
        } else if (parseInt($(window).width()) < 750) {
            $('.multiple_images_block').tjGallery({
              selector:'.multiple_image',
              margin: 12,
              rowMinHeight: 200
            });
        } 
      $( ".multiple_image img" ).addClass( "fade-in" );
    })
